module.exports = __webpack_public_path__ + "assets/external-link-3b4c92b58bdff619bb0714c166a32f4d.svg";